import { usePageMeta } from "@/hooks/usePageMeta";
import { faqs, forecasts, siteInfo } from "@/mocks/forecast";
import Hero from "@/pages/home/components/Hero";
import NewsTicker from "@/pages/home/components/NewsTicker";
import TodayForecast from "@/pages/home/components/TodayForecast";
import SignalSection from "@/pages/home/components/SignalSection";
import CategoriesSection from "@/pages/home/components/CategoriesSection";
import WatchGuide from "@/pages/home/components/WatchGuide";
import VoiceSection from "@/pages/home/components/VoiceSection";
import FaqSection from "@/components/feature/FaqSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";

export default function Home() {
  usePageMeta({
    title: "看料大瓜 - 预告前瞻与瓜田预警，提前蹲守潜在爆料",
    description:
      "看料大瓜专注预告前瞻与瓜田预警，整理影视、音乐、综艺、直播与商业领域的发酵信号，帮你提前锁定即将引爆的潜在爆料，快人一步掌握动态。",
    keywords: "看料大瓜,看料大瓜预告,看料大瓜前瞻,看料大瓜蹲守,瓜田预警,提前爆料",
    path: "/",
    type: "website",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        alternateName: "看料大瓜预告前瞻",
        url: "/",
        description: siteInfo.description,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "/forecast?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        description: "专注娱乐与商业领域爆料预告前瞻的内容平台。",
        email: siteInfo.email,
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "今日预告前瞻",
        itemListElement: forecasts.slice(0, 4).map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.title,
          url: `/forecast/${item.id}`,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ],
  });

  return (
    <>
      <Hero />
      <NewsTicker />
      <TodayForecast />
      <SignalSection />
      <CategoriesSection />
      <WatchGuide />
      <VoiceSection />
      <FaqSection />
      <SubscribeSection />
    </>
  );
}